<template>
    <edit></edit>
</template>

<script>
    import edit from './activity_new_edit.vue'

    export default {
        name: 'activity_new_add',

        components: {
            edit
        }
    }
</script>